export default "__VITE_ASSET__B71E_bkM__"